import { ICompany, IUpdateCompanyData } from "@/api/mainPage/company/interface";
import {
	PROFILE_KEY,
	profileStorageEntity,
	profileNameStorageEntity,
	PROFILE_NAME_KEY
} from "./storage";
import { IProfileEntity } from "./interface";
import store from '@/store';
import { PROFILE_MODULE_NAME } from "@/store/modules/profile";

export const profileEntity = {

	get profileData(): IProfileEntity | null {
		// const profile: string = profileStorageEntity[PROFILE_KEY] || '';
		//
		// return profile ? JSON.parse(profile) : null;
		return this.profileState;
	},

	set profileData(v: IProfileEntity | null) {
		// try {
		// 	profileStorageEntity[PROFILE_KEY] = !v ? '' : JSON.stringify(v);
		// } catch (err) {
		// 	console.log(err);
		// }
		this.profileState = v
	},

	get company(): IUpdateCompanyData | null {
		return store.getters[`${PROFILE_MODULE_NAME}/company`];
	},

	set company(v: IUpdateCompanyData | null) {
		store.commit(`${PROFILE_MODULE_NAME}/setCompany`, v);
	},

	get profileState(): IProfileEntity | null {
		return store.getters[`${PROFILE_MODULE_NAME}/profile`];
	},

	set profileState(v: IProfileEntity | null) {
		store.commit(`${PROFILE_MODULE_NAME}/setProfile`, v);
	},

	get profileName(): string {
		return profileNameStorageEntity[PROFILE_NAME_KEY] || '';
	}

};